import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import dayjs from "@/lib/day";
import { gql } from "@apollo/client";
import { createPageInfo } from "./helper";
export const typeDef = gql`
  type ProductOrders @cacheControl(maxAge: 0) {
    order_id: Int
    name: String
    created_at: String
    order: OrderType
    entitlements: [Entitlement]
  }
  type ProductOrdersResponse {
    data: [ProductOrders]
  }

  type OrderType {
    finished_at: String
    payment_amount: Int
    payment_instrument: paymentInstrumentType
  }

  type paymentInstrumentType {
    payment_method_id: Int
    values: paymentInstrumentValue
  }

  type paymentInstrumentValue {
    card_type: String
    card_number: String
  }

  type orderValue {
    product_price: Int
    discount_name: String
    transaction_start_at: String
  }

  type OrderData @cacheControl(maxAge: 0) {
    name: String
    payment_amount: Int
    payment_instrument: paymentInstrumentType
    values: orderValue
    created_at: String
    order_type: String
  }

  type OrdersResult {
    data: [OrderData]
    pageInfo: PageInfo
  }

  type Query {
    productOrders(
      with_order: Boolean
      with_payment_instrument: Boolean
      with_entitlements: Boolean
      type: String
    ): ProductOrdersResponse

    orders(offset: Int, limit: Int, year: Int): OrdersResult
  }
`;
export const resolvers = {
  Query: {
    productOrders: async (_parent, args, _ref) => {
      let {
        req,
        dataSources
      } = _ref;
      let result = await dataSources.orders.getProductOrders(args);
      const now = dayjs();
      if (args.type === "is-entitled") {
        result.product_orders = result.product_orders.filter(element => {
          var _element$entitlements, _element$entitlements2, _element$entitlements3, _element$entitlements4;
          if (element.product.values.adult_flag === false && (element === null || element === void 0 || (_element$entitlements = element.entitlements) === null || _element$entitlements === void 0 ? void 0 : _element$entitlements.length) !== 0 && !(element !== null && element !== void 0 && (_element$entitlements2 = element.entitlements) !== null && _element$entitlements2 !== void 0 && (_element$entitlements2 = _element$entitlements2[0]) !== null && _element$entitlements2 !== void 0 && _element$entitlements2.end_at)) {
            return true;
          } else if (element.product.values.adult_flag === false && (element === null || element === void 0 || (_element$entitlements3 = element.entitlements) === null || _element$entitlements3 === void 0 ? void 0 : _element$entitlements3.length) !== 0 && element !== null && element !== void 0 && (_element$entitlements4 = element.entitlements) !== null && _element$entitlements4 !== void 0 && (_element$entitlements4 = _element$entitlements4[0]) !== null && _element$entitlements4 !== void 0 && _element$entitlements4.end_at) {
            var _element$entitlements5;
            return dayjs(element === null || element === void 0 || (_element$entitlements5 = element.entitlements) === null || _element$entitlements5 === void 0 || (_element$entitlements5 = _element$entitlements5[0]) === null || _element$entitlements5 === void 0 ? void 0 : _element$entitlements5.end_at).isAfter(now);
          }
        });
      }
      return {
        data: result.product_orders
      };
    },
    orders: async (_parent, args, _ref2) => {
      let {
        dataSources
      } = _ref2;
      const res = await dataSources.user.userOrders(args);
      console.log("orders", res);
      return {
        data: res.orders,
        pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
          count: res.total_count
        }))
      };
    }
  }
};